<script>
import { trainerComputed, homeComputed, authComputed, homeMethods } from '@state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {
      placeholder: require('@assets/images/placeholder-avatar.png'),
      width: '600px',
    };
  },
  beforeMount() {},
  mounted() {
    if (document.getElementsByClassName('owl-stage') && document.getElementsByClassName('owl-stage').length > 0) {
      this.width = document.getElementsByClassName('owl-stage')[0].style.width;
    }
  },
  computed: {
    ...trainerComputed,
    ...homeComputed,
    ...authComputed,
    trainerAvatar() {
      return this.myTrainer &&
        this.myTrainer.mediaAssets &&
        this.myTrainer.mediaAssets.avatarImage &&
        this.myTrainer.mediaAssets.avatarImage.url
        ? this.myTrainer.mediaAssets.avatarImage.url
        : this.placeholder;
    },
  },
  methods: {
    ...homeMethods,
    toChat() {
      this.$router.push({ name: 'chat' });
    },
  },
};
</script>

<template>
  <div class="row say-hello">
    <div class="col-4 avatar-wrapper">
      <img :src="trainerAvatar" />
    </div>
    <div class="col note-wrapper">
      <div class="note">
        <p>I’m just finishing up your program! I will hit you up when I have it uploaded and you’re ready for day 1!</p>
      </div>
    </div>
    <BaseButton @click="toChat" class="button btn-primary large">
      <p><BaseIcon class="icon-comment-dots" name="comment-dots" prefix="far" />Say Hello</p>
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.say-hello {
  align-items: center;
  background-color: white;
  border-radius: 1.2rem;
  box-shadow: 0 2.88685px 25.9817px #d6d6d6;
  flex-direction: row;
  flex-wrap: unset;
  left: auto;
  margin-bottom: 2.3rem;
  margin-left: auto;
  margin-left: 2rem;
  margin-right: auto;
  margin-right: 2rem;
  max-width: 100%;
  padding: 1.5rem;
  padding-bottom: 2.5rem;
  position: relative;
  right: auto;
  .note-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: unset;
    text-align: start;
    p {
      line-height: 2.1rem;
    }
  }
  .avatar-wrapper {
    align-items: flex-start;
    align-self: flex-start;
    display: flex;
    max-width: fit-content;
    padding-left: unset;
    padding-right: unset;
    img {
      border-radius: 50%;
      height: 4.5rem;
      object-fit: cover;
      width: 4.5rem;
    }
  }

  .btn-primary {
    align-items: center;
    display: flex;
    height: 3.5rem;
    justify-content: center;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    max-height: 6rem;
    padding: 2vw 4vw;
    position: absolute;
    right: 0;
    top: 84%;
    width: 35%;
    svg {
      border-width: 1px;
      height: 2.1rem;
      margin-right: 7px;
      width: 2.1rem;
      path {
        border-width: 1px;
      }
    }
    p {
      align-items: center;
      color: #fff;
      display: flex;
      font-style: normal;
      font-weight: 500;
      justify-content: center;
      margin-bottom: unset;
      text-align: center;
      text-transform: capitalize;
      white-space: nowrap;
      @include calc-font-size(1.2);
    }
  }
}
</style>
